import React from 'react'
import CommentAnnotation from './CommentAnnotation'
import AnnotationOverlay from './AnnotationOverlay'
import AdAnnotations from './AdAnnotations'

class AdAnnotationOverlay extends React.Component {
  constructor(props) {
    super(props)
    this.state = {step: 'new', type: this.props.annotation.simple_type};

    if (this.props.annotation.id != null) {
      this.state.step = 'show';
    }
    this.handleTypeSelect = this.handleTypeSelect.bind(this)
  }

  changeAnnotationType() {
    this.setState({step: 'new'});
  }

  handleTypeSelect(e) {
    e.preventDefault();
    const type = $(e.target).data('label')
    let at = this.props.annotationTypes.find((t) => t.label == type)
    let step = 'intro';
    this.props.annotation.type = at.class;
    this.props.annotation.type_label = at.label;
    if (at.type_label == "add_files") {
      AdAnnotations.init().saveAddPhotoAnnotation(this.props.annotation, true)
    } else {
      this.setState({type: at.type_label, step: step})
    }
  }

  addFirstMessage(id){
    return {
      id: id,
      role_type: "area_director",
      role_name: "Area Director",
      commented_at: this.props.annotation.created_at
    }
  }

  setFirstAnnotationMessage(){
    if (!this.props.annotation.messages[0] || !this.props.annotation.messages[0].id.toString().includes(this.state.type)) {
      this.props.annotation.messages.unshift(this.addFirstMessage(this.state.type))
    }
  }

  commentAnnotation() {
    return (
      <CommentAnnotation
        klass={this.props.klass}
        onSelect={this.handleTypeSelect}
        id={this.props.number}
        annotation={this.props.annotation}
        roleType={this.props.roleType}
        annotationTypes={this.props.annotationTypes}
        readOnly={this.props.readOnly}
        />
    )
  }

  render() {
    let overlayContent = null;
    let commentAnnotationTypes = ['comment', 'post', 'headline', 'description', "website"]
    switch (this.state.step) {
      case 'new':
        overlayContent = this.commentAnnotation();
        break;
      default:
        if (commentAnnotationTypes.includes(this.state.type)) {
          overlayContent = this.commentAnnotation();
        } else if (this.state.type == 'add_files' || this.state.type == 'cta') {
          this.setFirstAnnotationMessage()
          overlayContent = this.commentAnnotation();
        } else {
          overlayContent = <p>{this.state.type} Annotation Here</p>
        }
    }

    return (
      <AnnotationOverlay
        popoverId={this.props.number}
        annotation={this.props.annotation}
        overlayContent={overlayContent}
        annotationId={this.props.number}
        roleType={this.props.roleType}
        />
    );
  }
}

export default AdAnnotationOverlay
